<template>
  <div>
    <div id="equipment-option" class="mt-4" >
      <h4 class="mt-2">{{ isTenG ? '10Gbps connections include XWi' : 'Add premium home WiFi'}}</h4>
      <div class="row">
        <div class="col-lg-7">
          <!-- If there are no routers left for the desired speed -->
          <div id="get-xwi-oos" class="w-100" v-if="!activeRouterAvailable">
            <h4 class="mb-3">&nbsp;</h4>
            <table>
              <tr valign="top" style="color:#666;">
                <td>
                  <img src="https://asset.xmission.com/xwi/xwi-router-app.png" class="ml-2 mb-2 mr-2" height="100" style="filter: grayscale(100%); opacity:0.5">
                </td>
                <td class="pr-3 pl-3 w-100">
                  <b class="d-block mb-2">Temporarily Out of Stock</b>
                  New routers arriving soon. <br />Please
                  <a style="color: #007bff" href="tel:8015390852"><b>call (801) 539-0852</b></a> or <a style="color: #007bff" href="https://chat.xmission.com" target="_blank"><b>chat</b></a> for exact date.
                  <br clear="all">
                </td>
              </tr>
            </table>
          </div>
          <!-- If there are routers available for the desired speed -->
          <label class="mb-3" @click="setNeedsRouter(true)" v-else>
            <input type="radio" :name="isTenG ? 'xtndrs' : 'xwi'" :class="isTenGRouter ? 'xwi-xtndrs' : ''" id="xwi-radio" :checked="isTenG">
            <div id="get-xwi" class="w-100">
              <h4 class="mb-3">&nbsp;</h4>
              <table>
                <tr>
                  <td>
                    <img :src="routerImageLink" :class="isTenGRouter ? '' : 'd-none d-md-block'" height="200" :style="isTenGRouter ? 'margin:0 -30px 0 10px' : 'margin-right:-30px'">
                  </td>
                  <td :class="isTenGRouter ? 'pr-3 pl-3 pb-3 w-100': 'pr-3 pl-3 w-100'">
                    <div id="get-xwi-headline" v-if="grossMonthlyRateReady">
                      <strong class="mb-1">Total home Internet solution</strong>
                      <center v-if="!isTenG"><b class="price">${{ grossMonthlyRate }}</b>/mo</center>
                    </div>
                    <div id="xwi-benys" :class="isTenGRouter ? 'w-100': ''">
                      <b>Control your home WiFi with ease</b>
                      <ul v-if="!isTenGRouter">
                        <li>XWi 1Gbps WAN WiFi 6 Router (4x1Gbps LAN) and app</li>
                        <li>Remote XMission support for hassle-free maintenance</li>
                        <li>Up to 250 devices with 2,500 sq ft coverage</li>
                        <li>Powerful parental controls and protection from malware and viruses</li>
                      </ul>
                      <ul v-else>
                        <li>XWi Premium WiFi 6e router and app</li>
                        <li>Remote XMission support for hassle-free maintenance</li>
                        <li>Powerful parental controls and protection from malware and viruses</li>
                        <li>Up to 250 devices with 2,500 sq ft coverage</li>
                      </ul>
                      <a v-if="isTenGRouter" href="https://xmission.com/xwi" target="_blank" class="btn btn-info btn-sm float-right">Learn more</a>
                    </div>
                    <br clear="all">
                  </td>
                </tr>
              </table>
            </div>
          </label>
        </div>
        <div class="col-lg-3" v-if="!isTenG">
          <label class="mb-3" @click="setNeedsRouter(false)">
            <input type="radio" name="xwi" id="none-radio">
            <div id="get-nothing">
              <h4>No thanks</h4>
              <div>I will provide my own router</div>
            </div>
          </label>
        </div>
        <div class="col-lg-3" v-else>
          <label @click="setNeedsRouter(false)">
            <input type="radio" name="xtndrs" class="xwi-xtndrs" id="none-radio">
            <div id="get-nothing">
              <h4 class="mb-3">Opt out</h4>
              <div>I will provide my own router</div>
            </div>
         </label>
        </div>
      </div>
      <button v-if="isTenG" class="btn btn-outline-dark" @click="ten_g_button_clicked = true">OK, proceed</button>
    </div>
    <transition v-on:enter="scrolldown('mesh-extender')">
      <div id="mesh-extender" class="mt-3" v-show="routerSelected && needsRouter && activeRouterAvailable">
        <h4 class="mt-2">Extend your WiFi</h4>
        <div class="row">
          <div class="col-lg-7">
            <div class="mb-3 w-100" v-if="!meshesAvailable">
              <div id="get-xtndr-oos" class="w-100">
                <h4 class="mb-3"><img src="https://asset.xmission.com/xwi/xwi-logo-black.png" alt="xwi"> Mesh Extender</h4>
                <table>
                  <tr valign="top" style="color:#666;">
                    <td>
                      <img src="https://asset.xmission.com/xwi/xwi-mesh-extender.png" class="mt-4" width="140" style="filter: grayscale(100%); opacity:0.5">
                    </td>
                    <td class="pr-3 pl-3 w-100">
                      <b class="d-block mb-2">Temporarily Out of Stock</b>
                      New mesh extenders arriving soon. <br />Please
                      <a style="color: #007bff" href="tel:8015390852"><b>call (801) 539-0852</b></a> or <a style="color: #007bff" href="https://chat.xmission.com" target="_blank"><b>chat</b></a> for exact date.
                      <br clear="all">
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <label class="mb-3 w-100" v-else>
              <input type="radio" name="xtndr" id="xtndr-radio" :checked="meshExtendersSelected && isMeshLease">
              <div id="get-xtndr" class="w-100">
                <h4 class="mb-3"><img src="https://asset.xmission.com/xwi/xwi-logo-black.png" alt="xwi"> Mesh Extender</h4>
                <table>
                  <tr valign="top">
                    <td>
                      <img src="https://asset.xmission.com/xwi/xwi-mesh-extender.png" class="mt-4" width="140">
                    </td>
                    <td class="pr-3 pl-3 w-100">
                    <div>
                      <b>Increase WiFi range from router to device</b>
                        <ul>
                          <li>Recommended for homes over 2,500 sq. ft.</li>
                          <li>Extend WiFi 6 coverage for harder to reach areas</li>
                          <li>Add one or more, as needed</li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="pr-3 pl-3 pb-3">
                      Quantity:
                      <select name="xtndr-qty" class="form-control d-inline" id="xtndr-qty" :value="meshQuantityDisplay" v-on:change="setMeshQuantity">
                        <!-- I guess "option" tags don't emit click events, so we need to do something different -->
                        <!-- https://stackoverflow.com/questions/51179656/chrome-doesnt-work-for-vuejs-v-onclick-in-option-tag -->
                        <option v-for="number of meshQuantitiesAvailable" :value="number">{{ number }}</option>
                      </select>
                    </td>
                    <td class="pl-3">
                      <div id="get-xtndr-price" class="faded">
                        <b class="price">${{ meshMonthlyRate }}</b>/mo <span class="each">each</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </label>
          </div>
          <div class="col-lg-3">
            <label class="mb-3">
              <input type="radio" name="xtndr" id="no-xtndr-radio" @click="setMeshNone" :checked="isMeshNone">
              <div id="no-xtndr">
                <h4 class="mb-3">No thanks</h4>
                <div>I don't need mesh extenders.</div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import RouterService from '../../../lib/ssu/input_models/router-service';
import helpers from '../../../lib/helpers';
import {mapGetters} from "vuex";
import logger from "../../../lib/logger";

export default {
  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  props : {
   service: {
      required: true,
      type: RouterService
   }
  },

  data (){
    return {
      scrolldown: helpers.scrolldown,
      ten_g_button_clicked: false,
      mesh_purchase: 'mesh_purchase',
      mesh_lease: 'mesh_lease',
      mesh_none: 'mesh_none',
      form_data: {
        needs_router: null,
        external_soid: null,
        router_model: null,
        mesh_quantity: null,
        mesh_type: null
      }
    }
  },

  computed: {
    meshQuantityDisplay () {
      if (!this.form_data.mesh_quantity) {
        return 0;
      }
      return this.form_data.mesh_quantity;
    },
    activeRouterAvailable () {
      return this.service.activeRouterAvailable();
    },
    activeRouterOption () {
      return this.service.getActiveRouterOption();
    },
    meshesAvailable() {
      return this.service.meshesAvailable();
    },
    meshQuantitiesAvailable() {
      let quantities = [];
      for (let i = 0; i <= this.meshesAvailable; i++) {
        quantities.push(i);
      }
      return quantities;
    },
    meshMonthlyRate () {
      return this.service.meshMonthlyRate();
    },
    grossMonthlyRateReady() {
      return this.service.getActiveRouterOption() !== null;
    },
    grossMonthlyRate() {
      return this.service.grossMonthlyRate();
    },
    isTenG() {
      return this.ssuSelectedSpeedId === 'speed_10000_sym';
    },
    isTenGRouter() {
      return ['speed_2000_sym', 'speed_2500_sym', 'speed_10000_sym'].includes(this.ssuSelectedSpeedId);
    },
    routerImageLink() {
      if (this.isTenGRouter){
        return 'https://asset.xmission.com/xwi/gigaspire+app.png';
      }
      return 'https://asset.xmission.com/xwi/xwi-router-app.png';
    },
    routerSelected() {
      if (this.isTenG) {
        return this.ten_g_button_clicked;
      }
      return this.form_data.needs_router !== null;
    },
    needsRouter () {
      return this.form_data.needs_router;
    },
    meshExtendersSelected () {
      logger.debug('mesh extender selected', this.form_data.mesh_quantity, this.form_data.mesh_type)
      return this.form_data.mesh_quantity !== null && this.form_data.mesh_type !== null;
    },
    isMeshLease() {
      logger.debug('isMeshLease', this.form_data.mesh_type, this.mesh_lease)
      return this.form_data.mesh_type === this.mesh_lease;
    },
    isMeshNone () {
      return this.form_data.mesh_type === this.mesh_none;
    },
    serviceReady () {
      return this.routerSelected && ((this.needsRouter && this.meshExtendersSelected) || !this.needsRouter);
    },
    formData() {
      return this.form_data;
    },
    ...mapGetters([
      'ssuSelectedSpeedId'
    ])
  },

  methods: {
    setNeedsRouter(needs_router) {
      logger.debug('setNeedsRouter', needs_router);
      this.form_data.needs_router = needs_router;
      this.form_data.router_model = this.activeRouterOption.router_model;
      this.form_data.external_soid = this.activeRouterOption.external_soid;
      if (!needs_router) {
        this.removeRouter();
      }
    },
    removeRouter() {
      this.form_data.mesh_quantity = 0;
      this.form_data.mesh_type = this.mesh_none;
      this.form_data.router_model = null;
      this.form_data.external_soid = null;
      this.form_data.needs_router = false;
    },
    setMeshQuantity(event) {
      let quantity = event.target.value;
      if (quantity > 0) {
        this.form_data.mesh_quantity = quantity;
        this.form_data.mesh_type = this.mesh_lease;  // for now we just set this
      }
      else {
        this.setMeshNone();
      }
    },
    setMeshNone() {
      this.form_data.mesh_quantity = 0;
      this.form_data.mesh_type = this.mesh_none;
    },
    setMeshNull() {
      this.form_data.mesh_quantity = null;
      this.form_data.mesh_type = null;
    }
  },

  watch: {
    isTenG (new_val, old_val) {
      // if 10 G is selected, set the default to true
      if (new_val && !old_val) {
        this.form_data.needs_router = true;
        this.setMeshNull();
        logger.debug('10G selected', this.form_data);
      }
      // else if it is unselected, set the default to unset
      else if (old_val && !new_val) {
        this.form_data.needs_router = null;
        this.setMeshNull();
        logger.debug('10G unselected', this.form_data);
      }
    },
    serviceReady(new_val, old_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },
    formData: {
      handler(new_val, old_val) {
        this.$emit('input', new_val)
      },
      deep: true
    }
  }
}
</script>


<style scoped>

#get-xwi, #get-nothing {border-radius:6px; border:1px solid #bbb;}

#equipment-option label {position:relative; width:100%;}

#get-xwi, #get-nothing {overflow:hidden}

#xwi-radio:checked+#get-xwi, #none-radio:checked+#get-nothing {
  border-color:black;
  box-shadow:1px 1px 15px #ccc;
}

#get-xwi:hover, #get-nothing:hover {
  border-color:#888;
  cursor:pointer;
  box-shadow:1px 1px 2px #ccc;
}

#equipment-option label input {
  position:absolute; top:10px;
  left:10px; z-index:200
}

#get-xwi h4 {
  background:url(https://asset.xmission.com/xwi/xwi-home-bg.png);
  background-position:-10px center;
  color:white; padding:18px 20px 20px 180px;
  background-repeat:no-repeat;
  background-color:#040707;
  font-size:24px;
  line-height:25px;
  height:80px
}

#get-nothing {
  padding: 8px 12px 8px 32px;
}

#get-xwi-headline {position:relative;}

#get-xwi-headline strong, #g0t-xwi-headline strong {
  display:block;
  padding-bottom:3px;
  font-size:20px;
  color:#0290AE;
  border-bottom:2px solid #0290AE;
}

#xwi-benys {
  padding:6px 0 0 40px;
  float:left;
  font-size:14px;
}

#xwi-benys ul {
  padding-left:1.2em;
}

/* mesh extender styles */
#mesh-extender label, #no-xtndr label {position:relative;}

#mesh-extender label input,  #no-xtndr label input  {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 200;
}

#get-xtndr, #no-xtndr {
  border-radius: 6px;
  border: 1px solid #bbb;
  overflow:hidden;
}

#get-xtndr h4 {
  background:#111;
  color:white;
  padding:8px 0 8px 32px;
}

#get-xtndr h4 img {
  height:20px;
  vertical-align:baseline;
}

#no-xtndr {
  padding:8px 12px 8px 32px
}

#get-xtndr ul {
  padding-left:1.2em;
  font-size:95%;
}

#get-xtndr:hover, #no-xtndr:hover {
  border-color:#888;
  cursor:pointer;
  box-shadow:1px 1px 2px #ccc;
}

#xtndr-radio:checked+#get-xtndr, #no-xtndr-radio:checked+#no-xtndr {
  border-color:black;
  box-shadow:1px 1px 15px #ccc;
}

.compact-input-group, .compact-input-group .form-control, .compact-input-group .input-group-btn {
  width:auto !important;
  display:inline-block !important;
}

.compact-input-group .input-group-btn button {
  border-top-left-radius:0px;
  border-bottom-left-radius:0px;
}

.liteMode a {
   color: white;
}

/* out of stock styles */
#get-xwi-oos {
  border-radius:6px;
  border:1px solid #bbb;
  overflow:hidden
}

#get-xwi-oos h4 {
  background:url(https://asset.xmission.com/xwi/xwi-home-bg.png);
  background-position:-10px center;
  color:white; padding:18px 20px 20px 180px;
  background-repeat:no-repeat;
  background-color:#040707;
  font-size:24px;
  line-height:25px;
  height:80px
}

#get-xtndr-oos {
  border-radius: 6px;
  border: 1px solid #bbb;
  overflow:hidden;
}

#get-xtndr-oos h4 {
  background:#111;
  color:white;
  padding:8px 0 8px 32px;
}

#get-xtndr-oos h4 img {
  height:20px;
  vertical-align:baseline;
}

#get-xtndr-oos table {
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// XWiService.vue?d8056c80